/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_D2dInputs */

const en_mk_sol_konsultan_d2d = /** @type {(inputs: Mk_Sol_Konsultan_D2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The agent summarises the attachments and hunts for precedent inside the workspace, listing each source it used.`)
};

const id_mk_sol_konsultan_d2d = /** @type {(inputs: Mk_Sol_Konsultan_D2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen merangkum lampiran dan mencari preseden di dalam workspace, lalu menuliskan sumbernya satu per satu.`)
};

/**
* | output |
* | --- |
* | "The agent summarises the attachments and hunts for precedent inside the workspace, listing each source it used." |
*
* @param {Mk_Sol_Konsultan_D2dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_d2d = /** @type {((inputs?: Mk_Sol_Konsultan_D2dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_D2dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_d2d(inputs)
	return en_mk_sol_konsultan_d2d(inputs)
});